import React from "react";
import Layout from "@app/Layout";
import Canonical from "@shared/head/Canonical";
import Breadcrumbs from "@shared/head/Breadcrumbs";

import Hero from "@features/sales/Hero";
import Features from "@features/sales/Features";
import Seats from "@features/sales/Seats";
import Steps from "@features/sales/Steps";
import FinalCTA from "@features/sales/FinalCTA";

export const Head = () => (
  <>
    <title>Dashly for sales: let your team focus on the hot leads</title>
    <meta
      name="description"
      content="Don't miss the hottest lead, focus on deals that matter most and sell more with Dashly"
    />
    <Canonical url="https://www.dashly.io/sales/" />
    <Breadcrumbs
      list={[
        { name: "Dashly", url: "https://www.dashly.io/" },
        { name: "Dashly for sales", url: "https://www.dashly.io/sales/" },
      ]}
    />
  </>
);

export default function SalesPage({ location }: { location: Location }) {
  return (
    <Layout location={location} className="new-design ds-2026">
      <Hero />
      <Features />
      <Seats />
      <Steps />
      <FinalCTA />
    </Layout>
  );
}
